import styled from 'styled-components';

export const UiOnlineExamModal = styled.div`
	display: block;
`;